import { sharedPreset } from '../shared-preset/preset';
import { getIntersectionObserver } from './intersection-listener';
export var isVisible = function (_a) {
    var event = _a.event;
    return event.isIntersecting;
};
export var getObservable = function (attributes, _getInterObserver) {
    if (_getInterObserver === void 0) { _getInterObserver = getIntersectionObserver; }
    if (attributes.scrollObservable) {
        return attributes.scrollObservable;
    }
    return _getInterObserver(attributes);
};
export var intersectionObserverPreset = Object.assign({}, sharedPreset, {
    isVisible: isVisible,
    getObservable: getObservable
});
//# sourceMappingURL=preset.js.map